import * as actions from '../actions/quote';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestQuoteScheduleInfo(sources) {
  const request$ = sources.ACTION.filter(
    action => action.type === ActionTypes.GET_QUOTE_SCHEDULE_INFO,
  ).map(action => ({
    url: BASE_URL + 'api/quotes/scheduleInfo',
    category: 'requestQuoteScheduleInfo',
    method: 'GET',
    type: 'application/json',
    withCredentials: true,
  }));

  let httpResponse$ = sources.HTTP
    .select('requestQuoteScheduleInfo')
    .map(response => {
      response.replaceError(err => xs.of(err));
    })
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getQuoteScheduleInfoSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$,
  };
}

export function requestQuoteScheduleInfoFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuoteScheduleInfo')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuoteScheduleInfoFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuoteProposalForms(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_PROPOSAL_FORMS)
        .map(action => ({
            url: BASE_URL + 'api/quotes/quoteDocument/' + action.payload.id,
            category: 'requestQuoteProposalForms',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuoteProposalForms')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuoteProposalFormsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuoteProposalFormsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuoteProposalForms')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuoteProposalFormsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuotePolicyWordings(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_POLICY_WORDINGS)
        .map(action => ({
            url: BASE_URL + 'api/quotes/quoteDocument/' + action.payload.id,
            category: 'requestQuotePolicyWordings',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuotePolicyWordings')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuotePolicyWordingsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuotePolicyWordingsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuotePolicyWordings')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuotePolicyWordingsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuotePointsOfSale(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_POINTS_OF_SALE)
        .map(action => ({
            url: BASE_URL + 'api/quotes/quoteDocument/' + action.payload.id,
            category: 'requestQuotePointsOfSale',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuotePointsOfSale')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuotePointsOfSaleSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuotePointsOfSaleFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuotePointsOfSale')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuotePointsOfSaleFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestSendQuoteScheduleViaEmail(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.SEND_QUOTE_SCHEDULE_VIA_EMAIL)
        .map(action => ({
            url: BASE_URL + `api/quotes/${action.payload.quoteId}/sendEmail/${action.payload.productId}`,
            category: 'requestSendQuoteScheduleViaEmail',
            method: 'POST',
            send: action.payload.sendBody,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestSendQuoteScheduleViaEmail')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.sendQuoteScheduleViaEmailSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestSendQuoteScheduleViaEmailFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestSendQuoteScheduleViaEmail')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.sendQuoteScheduleViaEmailFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuoteSchedulesMessage(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_SCHEDULES_MESSAGE)
        .map(action => ({
            url: BASE_URL + 'api/quotes/SchedulesMessage',
            category: 'requestQuoteSchedulesMessage',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuoteSchedulesMessage')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuoteSchedulesMessageSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuoteSchedulesMessageFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuoteSchedulesMessage')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuoteSchedulesMessageFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuoteById(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_BY_ID)
        .map(action => ({
            url: BASE_URL + 'api/quotes/forms/' + action.payload.id,
            category: 'requestQuoteById',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuoteById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuoteByIdSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuoteByIdFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuoteById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuoteByIdFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuotePolicyOverview(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_POLICY_OVERVIEW)
        .map(action => ({
            url: BASE_URL + 'api/quotes/PolicyOverview',
            category: 'requestQuotePolicyOverview',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuotePolicyOverview')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuotePolicyOverviewSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuotePolicyOverviewFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuotePolicyOverview')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuotePolicyOverviewFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuoteMessages(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_MESSAGES)
        .map(action => ({
            url: BASE_URL + 'api/quotes/messages',
            category: 'requestQuoteMessages',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuoteMessages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuoteMessagesSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuoteMessagesFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuoteMessages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuoteMessagesFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuoteDefaultSettings(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_DEFAULT_SETTINGS)
        .map(action => ({
            url: BASE_URL + 'api/quotes/DefaultSettings',
            category: 'requestQuoteDefaultSettings',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuoteDefaultSettings')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuoteDefaultSettingsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuoteDefaultSettingsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuoteDefaultSettings')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuoteDefaultSettingsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuoteIPT(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_IPT)
        .map(action => ({
            url: BASE_URL + 'api/quotes/IPT',
            category: 'requestQuoteIPT',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuoteIPT')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuoteIPTSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuoteIPTFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuoteIPT')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuoteIPTFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestUpdateQuote(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.UPDATE_QUOTE)
        .map(action => ({
            url: BASE_URL + 'api/quotes/forms/' + action.payload.sendBody.id,
            category: 'requestUpdateQuote',
            method: 'PATCH',
            type: 'application/json',
            send: action.payload.sendBody,
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestUpdateQuote')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.updateQuoteSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestUpdateQuoteFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUpdateQuote')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.updateQuoteFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestCreateQuote(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.CREATE_QUOTE)
        .map(action => ({
            url: BASE_URL + 'api/quotes/forms',
            category: 'requestCreateQuote',
            method: 'POST',
            type: 'application/json',
            send: action.payload.sendBody,
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestCreateQuote')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .map(response => actions.createQuoteSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestCreateQuoteFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestCreateQuote')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==201)
        .map(response => actions.createQuoteFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuoteStatuses(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_STATUSES)
        .map(action => ({
            url: BASE_URL + 'api/quotes/statuses',
            category: 'requestQuoteStatuses',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuoteStatuses')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuoteStatusesSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuoteStatusesFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuoteStatuses')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuoteStatusesFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuoteQuestions(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_QUESTIONS)
        .map(action => ({
            url: BASE_URL + 'api/quotes/questions',
            category: 'requestQuoteQuestions',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuoteQuestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuoteQuestionsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuoteQuestionsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuoteQuestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuoteQuestionsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestQuoteMinimumPricing(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_QUOTE_MINIMUM_PRICING)
        .map(action => ({
            url: BASE_URL + 'api/quotes/minimumPricing',
            category: 'requestQuoteMinimumPricing',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuoteMinimumPricing')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getQuoteMinimumPricingSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    }
}

export function requestQuoteMinimumPricingFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuoteMinimumPricing')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getQuoteMinimumPricingFailed(response));

    return {
        ACTION: httpResponse$
    };
}
